import moment from "moment";
import React from "react";
import URL from "../../../../Main/url";

const InvoiceA5Header = React.forwardRef((props, ref) => {
  const { values } = props;

  return (
    <div ref={ref} style={styles.container}>
      <div className="text-black-900 text-[0.65rem] text-center">
        <div className="text-center">
          {values?.branch?.image ? (
            <div className="flex justify-center">
              <div className="text-xl pb-1">
                <img
                  className="w-[50px] h-[50px]"
                  src={`${URL}/uploads${values?.branch?.image}`}
                />
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="text-medium text-xl">{values?.branch?.name}</div>
          <div className="text-medium">{values?.branch?.category}</div>
        </div>
      </div>
      <div className="text-black-900 text-[0.65rem] text-center pt-1">
        {/* <span>C.R.&nbsp;:&nbsp;1233305,&nbsp;</span>
                    <span>P.O&nbsp;Box&nbsp;:&nbsp;5678,&nbsp;</span>
                    <span>P.O&nbsp;Code&nbsp;:&nbsp;342,&nbsp;</span>
                    <span>Fax&nbsp;:&nbsp;2132435,&nbsp;</span>
                    <span>Tel&nbsp;:&nbsp;22876756,&nbsp;</span> */}
        <span>
          Email&nbsp;:&nbsp;
          {values?.branch?.email ? values?.branch?.email + ", " : ""}
          &nbsp;
        </span>
        <span>
          Phone&nbsp;:&nbsp;
          {values?.branch?.phone ? values?.branch?.phone : ""}
          &nbsp;
        </span>
        {/* <span>F.Code&nbsp;:&nbsp;8756432,&nbsp;</span> */}
        <div>
          {values?.branch?.area ? values?.branch?.area + ", " : ""}
          {values?.branch?.city ? values?.branch?.city + ", " : ""}
          {values?.branch?.country ? values?.branch?.country : ""}
        </div>
        <div>VATIN&nbsp;:&nbsp;{values?.branch?.tax}</div>
      </div>
      {/* heading */}
      <hr className="my-1 border-t-black-900 border-black" />
      <div className="text-medium text-lg text-center">TAX INVOICE</div>
      {/* Billing values */}
      <div className="text-regular text-xs pb-6">
        <div className="flex justify-between">
          <div>
            <table>
              <tbody>
                <tr>
                  <td>Customer</td>
                  <td className="px-2">:</td>
                  <td className="text-right">
                    {values?.customer?.name
                      ? values?.customer?.name
                      : "Walk-in-customer"}
                  </td>
                </tr>
                <tr>
                  <td>Phone</td>
                  <td className="px-2">:</td>
                  <td className="text-right">
                    {values?.customer?.phone ? values?.customer?.phone : ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <table>
              <tbody>
                <tr>
                  <td>Invoice No</td>
                  <td className="px-2">:</td>
                  <td className="text-right">#INV-{values?.number}</td>
                </tr>
                <tr>
                  <td>Date</td>
                  <td className="px-2">:</td>
                  <td className="text-right">
                    {moment?.(values?.date)?.format?.("DD/MM/YYYY")}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Items Table */}
      <table style={styles.table}>
        <thead>
          <tr style={styles.tableHeader}>
            <th
              className="text-left pl-2 text-xs text-regular"
              style={styles.tableCell}
            >
              S.No
            </th>
            <th
              className="text-left text-xs text-regular"
              style={styles.tableCell}
            >
              Description
            </th>
            <th
              className="text-center text-xs text-regular"
              style={styles.tableCell}
            >
              Batch
            </th>
            <th
              className="text-center text-xs text-regular"
              style={styles.tableCell}
            >
              Expiry
            </th>
            <th
              className="text-center text-xs text-regular"
              style={styles.tableCell}
            >
              Unit
            </th>
            <th
              className="text-center text-xs text-regular"
              style={styles.tableCell}
            >
              Quantity
            </th>
            <th
              className="text-center text-xs text-regular"
              style={styles.tableCell}
            >
              Price
            </th>
            <th
              className="text-center text-xs text-regular"
              style={styles.tableCell}
            >
              Tax
            </th>
            <th
              className="text-right pr-2 text-xs text-regular"
              style={styles.tableCell}
            >
              Total
            </th>
          </tr>
        </thead>
        <tbody className="text-regular">
          {values?.details?.map((item, index) => (
            <tr key={index}>
              <td className="text-center pl-2 text-xs" style={styles.tableCell}>
                <div>{index + 1}</div>
              </td>
              <td className="text-left text-xs" style={styles.tableCell}>
                <div>{item?.name}</div>
              </td>
              <td className="text-center text-xs" style={styles.tableCell}>
                <div>
                  {item?.description?.number
                    ? `${item?.description?.number}`
                    : ""}
                </div>
              </td>
              <td className="text-center text-xs" style={styles.tableCell}>
                <div>
                  {item?.description?.expiry_date
                    ? `${moment?.(item?.description?.expiry_date)?.format(
                        "DD-MM-YYYY"
                      )}`
                    : ""}
                </div>
              </td>
              <td className="text-center text-xs" style={styles.tableCell}>
                {item?.unit_name}
              </td>
              <td className="text-center text-xs" style={styles.tableCell}>
                {item?.quantity}
              </td>
              <td className="text-center text-xs" style={styles.tableCell}>
                {item?.sale_price?.toFixed(3)}
              </td>
              <td className="text-center text-xs" style={styles.tableCell}>
                {item?.tax_amount?.toFixed(3)}
              </td>
              <td
                className="text-center text-right pr-2 text-xs"
                style={styles.tableCell}
              >
                {item?.total?.toFixed(3)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot className="text-regular">
          <tr
            // className="border-t-[2px] border-[#f0f0f0]"
            style={styles.totalRow}
          >
            <td
              className="text-regular text-gray-700 text-medium text-xs"
              style={styles.tableCell}
              colSpan="8"
              align="right"
            >
              Subtotal
            </td>
            <td className="text-right pr-2" style={styles.tableCell}>
              {values?.subtotal?.toFixed(3)}
            </td>
          </tr>
          <tr style={styles.totalRow}>
            <td
              className="text-regular text-gray-700 text-medium text-xs"
              style={styles.tableCell}
              colSpan="8"
              align="right"
            >
              Tax [VAT]
            </td>
            <td className="text-right pr-2" style={styles.tableCell}>
              {values?.taxamount?.toFixed(3)}
            </td>
          </tr>
          <tr style={styles.totalRow}>
            <td
              className="text-regular text-gray-700 text-medium text-xs"
              style={styles.tableCell}
              colSpan="8"
              align="right"
            >
              Discount
            </td>
            <td className="text-right pr-2" style={styles.tableCell}>
              {values?.discount?.toFixed(3)}
            </td>
          </tr>
          {/* <tr style={styles.totalRow}>
            <td
              className="text-regular text-gray-700 text-medium text-xs"
              style={styles.tableCell}
              colSpan="5"
              align="right"
            >
              Delivery
            </td>
            <td style={styles.tableCell}>{values?.discount?.toFixed(3)}</td>
          </tr> */}
          <tr style={styles.totalRow}>
            <td
              className="text-regular text-medium text-xs bg-[#f0f0f0]"
              style={styles.tableCell}
              colSpan="8"
              align="right"
            >
              Total
            </td>
            <td
              className="text-right pr-2 text-regular text-medium text-xs bg-[#f0f0f0]"
              style={styles.tableCell}
            >
              {values?.total?.toFixed(3)}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
});

const styles = {
  container: {
    width: "210mm", // A5 width
    height: "148mm", // A5 height
    padding: "2%",
    fontFamily: "Arial, sans-serif",
    fontSize: "12px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHeader: {
    backgroundColor: "#f0f0f0",
  },
  tableCell: {
    border: "0px solid #000",
  },
  totalRow: {
    fontWeight: "normal",
  },
  billingvalues: {
    marginBottom: "20px",
  },
};

export default InvoiceA5Header;
